<div class="panel-item">
  <div (click)="onToggle()" class="panel-header">
    <ng-content select="[panel-header]"></ng-content>
    <img [ngSrc]="isOpen() ? 'assets/img/up-carret.svg' : 'assets/img/down-carret.svg'"
         height="20"
         width="20">
  </div>
  @if (isOpen()) {
    <div class="panel-body">
      <ng-content select="[panel-body]"></ng-content>
    </div>
  }
</div>
